import PendoTable from '../../../../components/table/pendo-table.vue.js';
import PendoCsvModal from '../../../csv-modal/pendo-csv-modal.vue.js';
import PendoButton from '../../../../components/button/pendo-button.vue.js';

var script = {
  name: 'UserImpactDrawerContent',
  components: {
    PendoTable,
    PendoButton,
    PendoCsvModal
  },
  props: {
    impactedUsers: {
      type: Array,
      default: () => []
    },
    guideVisitorAggStatus: {
      type: String,
      required: true
    },
    csvAggState: {
      type: Object,
      default: () => ({})
    },
    productType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      cols: [{
        type: 'link',
        prop: 'visitorId',
        label: 'Visitor ID',
        sortable: true
      }],
      showCsvDownloadModal: false,
      engageHeaderText: 'Click on the individual user to view their timeline. Viewing their timeline may help you better understand what triggered the alert.',
      adoptHeaderText: 'Click on the individual user to view their Visitor Details.'
    };
  },
  watch: {
    'csvAggState.status': function (newValue) {
      if (newValue === 'loading') {
        this.showCsvDownloadModal = true;
      }
    }
  },
  methods: {
    onLinkClick(_ref) {
      let {
        row
      } = _ref;
      this.$emit('visitor-link-click', row.visitorId);
    },
    downloadCsv() {
      this.$emit('download-csv');
    }
  }
};

export { script as default };
//# sourceMappingURL=user-impact-drawer-content.vue2.js.map
